module.exports = __webpack_public_path__ + "img/rightOne-img.04d5b064.png";